import { Mutation } from 'vuex';
import { IModuleState } from './types';
import { flattenTree } from '@/utils/object';
import * as util from './util';

// 导航树
export const setMatNavTree: Mutation<IModuleState> = (state, payload) => {
  const treeList = util.navTreeBuild(payload.raw, []);
  state.tree.data = payload.raw ? treeList : state.tree.data;
  state.tree.list = flattenTree(treeList);
  state.tree.loading = !!payload.loading;
};

// 分类树
export const setMatCateTree: Mutation<IModuleState> = (state, payload) => {
  // 使各层级数据结构保持一致，方便递归
  const rootList = util.filterListBuild(payload.raw || []);
  const treeList = util.cateTreeBuild(rootList, []);
  state.cate.data = treeList;
  state.cate.list = flattenTree(treeList);
  state.cate.loading = !!payload.loading;
};

// 标签过滤项列表
export const setMatLabelList: Mutation<IModuleState> = (state, payload) => {
  const labelList = util.labelListBuild(payload.raw);
  state.label.data = labelList;
  state.label.list = labelList.reduce((acc, cur) => [...acc, ...cur.options], [] as any[]);
  state.label.loading = !!payload.loading;
};

// 颜色过滤项列表
export const setMatColors: Mutation<IModuleState> = (state, payload) => {
  state.colors.data = util.colorListBuild(payload.data);
  state.colors.loading = !!payload.loading;
};

// 实体类型字典
export const setEntityTypes: Mutation<IModuleState> = (state, payload) => {
  state.entityTypes.data = payload.data;
  state.entityTypes.loading = !!payload.loading;
};

// 图片列表
export const setMatImgList: Mutation<IModuleState> = (state, payload) => {
  state.images.params = payload.params;
  state.images.data = payload.data;
  state.images.pageSize = payload.pageSize;
  state.images.pageNum = payload.pageNum;
  state.images.total = payload.total;
  state.images.loading = !!payload.loading;
};

// 导航版本列表
export const setVersionList: Mutation<IModuleState> = (state, payload) => {
  state.versions.data = payload.raw ? util.versionListBuild(payload.raw) : payload.data;
  state.versions.loading = !!payload.loading;
};

// 已发布的导航树详情
export const setPublishTree: Mutation<IModuleState> = (state, payload) => {
  state.pubTrees.data = payload.raw ? util.navTreeBuild(payload.raw, []) : payload.data;
  state.pubTrees.loading = !!payload.loading;
};

// 带版本的导航树详情
export const setVersionTree: Mutation<IModuleState> = (state, payload) => {
  state.verTrees.data = payload.raw ? util.navTreeBuild(payload.raw, []) : payload.data;
  state.verTrees.loading = !!payload.loading;
};

// 弹窗(新增节点, 查看导航详情)
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type;
  state.dialog.data = payload.data;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.type = payload.type;
  state.confirm.data = payload.data;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loaded.type = payload.type;
  state.loaded.loading = !!payload.loading;
};

export const setExpanded: Mutation<IModuleState> = (state, payload) => {
  state.expanded.expand = payload.expand == null ? state.expanded.expand : !!payload.expand;
  state.expanded.tab = payload.tab == null ? state.expanded.tab : payload.tab;
};
